
export interface ILoadingPointHelperProps{
    IsMaxPercentageAvailable: boolean
}

export const InitialLoadingPointHelperProps: ILoadingPointHelperProps = { IsMaxPercentageAvailable: false};